export enum SidebarLinks {
  Index = '/',
  Employees = '/employees',
  Organization = '/organization',
  Events = '/events',
  Jobs = '/jobs',
  Requests = '/requests',
  Settings = '/settings',
}
